<template>
  <DetailPageWrap
    :titleCardOptions="titleCardOptions"
    :description="resultList2" >
    <template >
    <!-- <MultipleFilter class="multiple-wrap" :options="filterOptions" @chacked="mutipleChacked"></MultipleFilter> -->
      <div class="talent-detail-card-wrap">
        <!-- <div class="img-wrap" >
          <img class="img" :src="resultList3" alt="用户">
        </div> -->
        <MediaWrap class="audio-wrap" :url="imgUrl" :height="180"></MediaWrap>
        <div class="infos">
          <div class="name">{{resultList.name}}</div>
          <div>简介: {{resultList.introduction}}</div>
          <span class="line"></span>
          <a-row>
            <a-col :span="8">电话:{{resultList.phone}}</a-col>
            <a-col :span="16">邮箱:{{resultList.email}}</a-col>
          </a-row>
        </div>
      </div>
    </template>
  </DetailPageWrap>
</template>

<script>
// import MultipleFilter from '@/components/MultipleFilter'
import DetailPageWrap from '@/components/common/DetailPageWrap'
import { resultDetails, titleCardOptions } from './data'
import { checkTalentData } from '@/api/MTalentData.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      resultDetails,
      resultList: [],
      resultList2: [],
      imgUrl: '',
      titleCardOptions,
    }
  },
  components: {
    DetailPageWrap,
    // MultipleFilter
  },
  mounted() {
    this.initSetting() // 初始化设置
  },
  methods: {
    async initSetting() {
      const { uid } = this.$route.query
      const { data } = await checkTalentData(uid)
      this.resultList = data
      this.resultList2=[
        {
          contents: [
        data.info
      ]
        }
      ],
      this.imgUrl= data.fileVo[0].filePath
      // console.log(this.imgUrl);
    },
    mutipleChacked(){}
  }
}
</script>
<style scoped>
.infos{
  width: 10rem;
}
</style>